import { Box } from "@mui/material";

import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { AccountsandFinanceurl } from "../../../../config";
import { AccountTypesColumns } from "../../../../data/DynamicTable/Collumns";
import {
  allAccountCategories,
  allAccountTypes,
  allAccounts,
} from "../../../../data/Axios/queries";
import {
  AccountCategoriesColumns,
  AccountSubCategoriesColumns,
  AccountsColumns,
} from "../../../../data/DynamicTable/AccountsColumns";
import AccountsForm from "./form";
const base_url = AccountsandFinanceurl.uri;
const actions = {
  entity: "Accounts",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  showStatus: true,
};
function AccountsTable() {
  return (
    <Box m="2px">
      <DynamicTable
        title="Accounts"
        subtitle="Create, view or edit accounts"
        columns={AccountsColumns}
        FormComponent={AccountsForm}
        query={allAccounts}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default AccountsTable;



